
export default class Scens {
    constructor(controller) {
        this.controller = controller;
    }

    animation() {

        const animations = document.querySelectorAll("[data-item='animation']");

        if (animations) {

            animations.forEach(e => {

                const section = e.dataset.section;
                let offset = -100;
                
                if(section == 'benefits') {
                    offset = 200;
                }

                new ScrollMagic.Scene({
                    triggerElement: e,
                    duration: '100%',
                    offset: offset,
                    reverse: false,
                })
                .on('start', function () {
        
                    //setTimeout(() => {
                        e.classList.add("animation");
                    //},300);
        
                })
                .addTo(this.controller);
            });

        }
    }

    map(getMapboxLoad) {

        const map_block = document.querySelector("[data-item='map']");

        const contact_tab = document.querySelectorAll("[data-item='contact-tab']");

        if (map_block) {

        new ScrollMagic.Scene({
            triggerElement: '[data-item="map"]',
            duration: '100%',
            offset: -500,
            reverse: false
        })
            .on('start', function () {
                const id = map_block.getAttribute("id");
                const address = map_block.dataset.address;
                let lng = parseFloat(map_block.dataset.lng);
                let lat = parseFloat(map_block.dataset.lat);

                getMapboxLoad.then(res => {
                    mapboxgl.accessToken = 'pk.eyJ1Ijoic3R1ZGlva2FkciIsImEiOiJjank1aTd1cTcwNGRhM2RsZjhzdjkyZTM4In0.kM77q6fgLkETu4ZL0e99lw';
                    lng = lng;
                    lat = lat;
                    
                    var map = new mapboxgl.Map({
                        container: id,
                        center: [lng, lat],
                        zoom: 14,
                        dragPan: window.innerWidth > 992 ? true : false,
                        style: 'mapbox://styles/mapbox/streets-v10'
                    });
                    
                    var geojson = {
                        type: 'FeatureCollection',
                        features: []
                    };

                    // create all markers
                    allMarkers.forEach(key => {
                        let coordinate = {
                            "type": "Feature",
                            "properties": {
                                "id": key,
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinates": [key.lng, key.lat],
                                "address": key.address
                            }
                        }
                        geojson.features.push(coordinate);
                    });
                    
                    geojson.features.forEach(function(marker) {
                        var el = document.createElement('div');
                        el.className = 'marker';
                    
                        new mapboxgl.Marker(el)
                            .setLngLat(marker.geometry.coordinates)
                            .setPopup(new mapboxgl.Popup({offset: 25})
                            .setHTML(marker.geometry.address))
                            .addTo(map);
                    });

                    // if isset ontact tabs
                    if (contact_tab) {
                    contact_tab.forEach(link => {
                        // if change contact address
                        link.addEventListener("click", event => {
                            
                        const new_address = link.dataset.address;
                        let new_lng = parseFloat(link.dataset.lng);
                        let new_lat = parseFloat(link.dataset.lat);

                        map_block.setAttribute("data-address", new_address);
                        map_block.setAttribute("data-lng", new_lng);
                        map_block.setAttribute("data-lat", new_lat);

                        /* scroll to map if page contact */
                        const contact_page = document.querySelector("[data-item='contact-page']");

                        if (contact_page) {
                            let window_height = window.innerHeight;
                            let height = map_block.offsetHeight; 
                    
                            $('html, body').animate({
                            scrollTop: $('#map').offset().top - (window_height - height)
                            }, 800);
                        }
                        

                        map.flyTo({
                            center: [new_lng,new_lat],
                            essential: true // this animation is considered essential with respect to prefers-reduced-motion
                            });
                        });

                    });
                    }
                    
                    map.scrollZoom.disable();
                    }).catch(e => {
                        console.log(e);
                    });

                      

                    window.mapLoaded = map;
            })
            .addTo(this.controller);
        
        }
    
    }
    
    
}